const removeInvalidFlag = ({ target: input }) => {
  input.classList.remove('form__input--invalid');
  const error = input.parentNode.querySelector('.up-input__error');
  if (error) error.innerText = '';
};

const clearInvalidInputsOnChange = (connect = true) => {
  const inputs = document.querySelectorAll('.form__input');

  if (connect) {
    inputs.forEach((input) => {
      input.addEventListener('keydown', removeInvalidFlag);
      input.addEventListener('change', removeInvalidFlag);
    });
  } else {
    inputs.forEach((input) => {
      input.removeEventListener('keydown', removeInvalidFlag);
      input.removeEventListener('change', removeInvalidFlag);
    });
  }
};

export default clearInvalidInputsOnChange;
